module.exports = __webpack_public_path__ + "operace-nosu_8_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_8_before.jpg
// module id = 1142
// module chunks = 0